import React from 'react';
import ReactDOM from 'react-dom';
import { Clock, LogOut, RefreshCw, Key } from 'lucide-react';
import './SessionWarningModal.css';

const SessionWarningModal = ({
  show,
  remainingTime,
  onExtend,
  onLogout,
  reason = 'inactivity'
}) => {
  if (!show) return null;

  const isTokenExpiring = reason === 'token';

  return ReactDOM.createPortal(
    <div className="session-warning-overlay">
      <div className="session-warning-modal">
        <div className={`session-warning-icon ${isTokenExpiring ? 'token' : ''}`}>
          {isTokenExpiring ? <Key size={22} /> : <Clock size={22} />}
        </div>

        <h3>
          {isTokenExpiring
            ? 'Tu sesión está por expirar'
            : 'Sesión inactiva'}
        </h3>

        <p>
          {isTokenExpiring
            ? 'Por seguridad, tu sesión se cerrará pronto. Hacé clic en "Continuar trabajando" para renovarla.'
            : 'Por seguridad, tu sesión se cerrará automáticamente por inactividad.'}
        </p>

        <div className={`session-warning-timer ${isTokenExpiring ? 'token' : ''}`}>
          <span className="timer-value">{remainingTime}</span>
          <span className="timer-label">restantes</span>
        </div>

        <div className="session-warning-actions">
          <button className="btn-extend" onClick={onExtend}>
            <RefreshCw size={14} />
            Continuar trabajando
          </button>
          <button className="btn-logout" onClick={onLogout}>
            <LogOut size={14} />
            Cerrar sesión
          </button>
        </div>

        <p className="session-warning-hint">
          Hacé clic en "Continuar trabajando" para mantener tu sesión activa
        </p>
      </div>
    </div>,
    document.body
  );
};

export default SessionWarningModal;
